import { Job } from '../types/job';
import { boolHttp } from './http';
import { JobSubmit } from './urls';

const JobService = {
  submit: async (job: Job): Promise<boolean> => {
    const req = new Request(JobSubmit(), {
      method: 'POST',
      body: JSON.stringify(job),
    });
    return await boolHttp(req);
  },
};

export default JobService;
